import React, { useState } from "react";
import { Modal, Box } from "@mui/material";
import { ReactComponent as CsvNameModalBgImage } from "../../assets/images/csvNameModalBgImage.svg";
import InputComponent from "../UniversalComponents/InputComponent";
import Button from "../UniversalComponents/DefaultButton";

const UploadCsvConfirmNameModal = ({ open, onClose, handleCreate = async () => {} }) => {
  const [tableName, setTableName] = useState("");
  const [error, setError] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);

  const handleSubmit = async () => {
    setIsFileUploading(true);
    await handleCreate(tableName);
    setIsFileUploading(false);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl shadow-xl w-[500px] overflow-hidden">
        <div className="bg-[rgba(172,83,249,0.32)] p-6 flex justify-center">
          <CsvNameModalBgImage />
        </div>
        <div className="p-6 flex flex-col space-y-4">
          {/* <TextField
                        label="Table Name"
                        variant="outlined"
                        fullWidth
                        value={tableName}
                        onChange={(e) => setTableName(e.target.value)}
                        error={error}
                        helperText={error ? 'Already Exist' : ''}
                    /> */}

          <InputComponent
            value={tableName}
            onChange={(e) => setTableName(e.target.value)}
            error={error}
            helperText={error ? "Already Exist" : ""}
            className="w-full"
            variant="outlined"
            size="small"
            placeholder="Enter table name"
            InputProps={{
              endAdornment: <span className="text-gray-500">.csv</span>,
            }}
          />
          <div className="flex justify-end gap-3 mt-4">
            <Button
              onClick={handleSubmit}
              variant="primary"
              className="px-3 py-1 rounded-lg"
              isDisabled={tableName?.trim() === "" || isFileUploading}
            >
              {isFileUploading ? "Creating..." : "Create"}
            </Button>
            <Button onClick={onClose} variant="secondary" className="px-3 py-1 rounded-lg">
              Cancel
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default UploadCsvConfirmNameModal;
